import { Component } from "react";
import { withRouter } from "../../../withRouter";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import axios from "axios";
import cookie from "react-cookies";
class EpicSocial extends Component {
  constructor(props) {
    super(props);
    const companyID = cookie.load("companyID") || "";
    console.log(this.props);
    this.state = {
      companyID: companyID,
      showAddOutlet: true,
      windowHeight: window.innerHeight,
    };
  }
  componentDidMount() {
    this.loadOutlet();
     window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + this.state.companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
        }
      })
      .catch();
  }
  onRecallOulet(recall) {
    if (recall === true) {
      this.loadOutlet();
    }
  }
  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
    });
  };

  

  render() {
    let currentPage = "epicsocial-generate";
    let pageName = "generate?";
    if (this.props.location.pathname === "/clientpanel/epicsocial/generate") {
      currentPage = "epicsocial-generate";
      pageName = "generate?";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/inbox") {
      currentPage = "epicsocial-inbox";
      pageName = "inbox?";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/calendar") {
      currentPage = "epicsocial-calendar";
      pageName = "calendar?";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/history") {
      currentPage = "epicsocial-history";
      pageName = "history?";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/prompts") {
      currentPage = "epicsocial-prompts";
      pageName = "prompts?";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/settings/accounts") {
      currentPage = "epicsocial-settings";
      pageName = "settings?tab=accounts&";
    } else if (this.props.location.pathname === "/clientpanel/epicsocial/settings") {
      currentPage = "epicsocial-settings";
      pageName = "settings?";
    }
    
    const projectID = process.env.REACT_APP_SUPABASE_POST_PROJECT_ID;

    return (
      <div className="layout-wrapper layout-content-navbar reservation-main ">
        <div className="layout-container engage-main engage-v1">
          <Header {...this.props} currentPage={currentPage} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="card fv-plugins-bootstrap5">
                <div className="subcontent-enagev1 card-body row g-3">
                  <div className="flex-grow-1">
                    <iframe src={`${process.env.REACT_APP_EPICSOCIAL_URL}${pageName}token=${encodeURIComponent(localStorage.getItem(`sb-${projectID}-auth-token`))}`} title="EpicSocial" width="100%" height={this.state.windowHeight - 120}></iframe>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

export default withRouter(EpicSocial);
